import { render, staticRenderFns } from "./AddDesignationComponent.vue?vue&type=template&id=2c570a84&"
import script from "./AddDesignationComponent.vue?vue&type=script&lang=js&"
export * from "./AddDesignationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports